import axios from 'axios';

export default axios.create({
    baseURL: `https://legacy.tizeti.com/geniatechapi`,
});
